export const firebaseConfig = {
    apiKey: 'AIzaSyB2V2dSaqOXLrtuTfEx56Rw7yetj6Kfa6M',
    authDomain: 'zz2-packman.firebaseapp.com',
    databaseURL: 'https://zz2-packman.firebaseio.com',
    projectId: 'zz2-packman',
    storageBucket: 'zz2-packman.appspot.com',
    messagingSenderId: '962522652800',
};

export const freshServiceConfig = {
    apiKey: 'IiAbY68ljMT2JXz7rDO',
    Address: 'https://zz2.freshservice.com/api/v2/tickets',
};

/* Themes */
export const APP_THEMES = [
    'Default',
    'Dark',
];

export const MAP_CENTER_POSITION : { lat : number; long : number } = {
    lat: -23.5792,
    long: 30.1424,
};

export const SNACKBAR_WIDTH = 400;

/* Default rights (Pages accessible to all users) */
export const DEFAULT_RIGHTS = ['/faq'];

export const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT_DEFAULT_NO_TIME = 'DD/MM/YYYY';
export const TIME_FORMAT_DEFAULT = 'HH:mm:ss';
export const DATEPICKER_FORMAT_DEFAULT = 'YYYY-MM-DD';
export const DATEPICKER_FORMAT_DEFAULT_DATE_FNS = 'yyyy-MM-dd';
export const DATE_FORMAT_CSV = 'YYYYMMDD';
export const TIME_FORMAT_CSV = 'HH:mm';
export const DATE_FORMAT_TIMESTAMP_FROM_API = 'YYYY-MM-DDTHH:mm:ss';
export const DISPATCH_CSV_DATE_FORMAT = 'DD/MM/YYYY hh:mm:ss A';
export const DATEONLY_FINDING_SHEET_FILE = 'DD.MM.YYYY';

export const DATEONLY_PALTRACK_FILE = 'YYYYMMDD';
export const DATETIME_PALTRACK_FILE = 'YYYYMMDDHH:mm';
export const DATETIME_SECONDS_PALTRACK_FILE = 'YYYYMMDDHH:mm:ss';

/* Dashboard filters */
export const CATEGORY_EXPANDED_HEIGHT_STOCK = 370;
export const CATEGORY_EXPANDED_HEIGHT_COMPLIANCE = 400;
export const CATEGORY_COLLAPSED_HEIGHT = 40;
export const WHITE_SPACE_BASE_LEFT_STOCK = 144;
export const WHITE_SPACE_BASE_LEFT_COMPLIANCE = 124;

export const getMapIcon = (name : string) => {
    const iconsLocation = `${ASSET_BASE}/assets/icons/mapMarkers`;
    return `${iconsLocation}/${name}.svg`;
};

export const DISPATCH_INSTRUCTION_STATUSSES = [
    'Draft',
    'Planned',
    'Confirmed',
    'Instructed',
    'Staged',
    'Dispatched',
    'Received',
];

export const DISPATCH_INSTRUCTION_CAN_DOWNLOAD_PO_FILE_STATUSSES = [
    'Dispatched',
    'Received',
];

export const COMPLIANCE_STATUSSES = [
    'Draft',
    'Planned',
    'Inspecting',
];

export const COMPLIANCE_CSV_HEADINGS = [
    'EDI_PARTNER_ID',
    'EDI_FILE_VERSION',
    'FILE_CREATION_DATE',
    'FILE_CREATION_TIME',
    'REVISION',
    'TRAN_TYPE',
    'CONS_NO',
    'BOOKING_REFERENCE',
    'BILLING_PARTY',
    'EXPORTER',
    'UPN',
    'PHC',
    'SSCC',
    'SEQ_NO_SSCC',
    'SSCC_REV',
    'CARTON_ID',
    'SSCC_REF',
    'PUC',
    'ORCHARD',
    'COMMODITY',
    'VARIETY',
    'CLASS',
    'SIZE_COUNT',
    'PACK',
    'PACK_DATE',
    'PRE_PACK_TREATMENT',
    'INSP_SAMPLE_WEIGHT',
    'NETT_WEIGHT_PACK',
    'GROSS_WEIGHT_PACK',
    'UNIT_TYPE',
    'CARTONS',
    'PLT_QTY',
    'TARG_REGION',
    'TARG_COUNTRY',
    'PHYTO_IND',
    'PROTOCOL_EXCEPTION_IND',
    'INSP_STATUS',
    'INSP_RESULT',
    'REJECT_REASON1',
    'REJECT_REASON2',
    'REJECT_REASON3',
    'INSP_POINT',
    'INSPECTOR',
    'INSP_DATE',
    'INSP_TIME',
    'PACK_CATEGORY',
];

export const DISPATCH_CSV_HEADINGS = [
    'Dispatch ID',
    'From Depot',
    'To Depot',
    'Date',
    'Barcode',
    'No Cartons',
    'Commodity Code',
    'Variety Code',
    'Pack Code',
    'Grade Code',
    'Count Code',
    'Inventory Code',
    'Weight',
    'Sequence Number',
    'Farm Number',
    'Pallet Base Type',
];

export const VALID_DISPATCH_STATUS_DESTINATIONS : { [key : string] : Array<string> } = {
    Draft: [
        'Planned',
        'Confirmed',
        'Instructed',
    ],
    Planned: [
        'Draft',
        'Confirmed',
        'Instructed',
    ],
    Confirmed: [
        'Instructed',
    ],
    Instructed: [
    ],
    Staged: [
        'Dispatched',
    ],
    Dispatched: [
    ],
    Received: [],
};

export const ADMIN_OVERRIDE_STATUSSES : { [key : string] : Array<string> } = {
    Draft: [
    ],
    Planned: [
    ],
    Confirmed: [
        'Draft',
        'Planned',
        'Dispatched',
    ],
    Instructed: [
        'Draft',
        'Planned',
        'Dispatched',
        'Confirmed',
    ],
    Staged: [
    ],
    Dispatched: [
        'Received',
    ],
    Received: [],
};

/* Lots */

export const CONSTANT_LOT_TYPE_GUIDS = [
    'CONST_LOT_TYPE_BATCH',
    'CONST_LOT_TYPE_WASTE',
    'CONST_LOT_TYPE_INTAKE',
    'CONST_LOT_TYPE_ADJUSTMENT',
    'CONST_LOT_TYPE_STORAGE',
];

export const RIGHT_GRANTS : {[key : number] : string} = {
    0: 'VIEW',
    1: 'ADD',
    2: 'EDIT',
    4: 'DELETE',
    8: 'ADMIN',
    16: 'SUPER_ADMIN',
};
